import React from 'react';
import { Play, Loader2 } from 'lucide-react';

const ARAKKAL_LOGO = "/arakkal-logo.png";

export function IntroCard({ onStart }) {
  return (
    <div className="intro-card" data-testid="intro-card">
      <img src={ARAKKAL_LOGO} alt="Arakkal Estate" className="intro-logo" />
      <p className="intro-tagline">Direct Trade · Single Origin · Arabica</p>
      <button 
        className="intro-play-btn"
        onClick={onStart}
        data-testid="intro-play-btn"
      >
        <Play size={24} />
        <span>Watch the Story</span>
      </button>
    </div>
  );
}

export function ChapterInfo({ chapter, displayIndex, totalChapters }) {
  return (
    <div className="chapter-info" data-testid="chapter-info">
      <span className="chapter-number">
        Chapter {displayIndex + 1} of {totalChapters}
      </span>
      <h2 className="chapter-title">{chapter.title}</h2>
    </div>
  );
}

export function Subtitles({ text, isVisible }) {
  if (!isVisible || !text) return null;
  
  return (
    <div className="subtitles" data-testid="subtitles">
      <p>{text}</p>
    </div>
  );
}

export function ChapterCard({ 
  chapter, 
  index, 
  isActive, 
  hasAudio, 
  isProcessing, 
  imageUrl, 
  Icon, 
  onClick 
}) {
  return (
    <button
      className={`chapter-card ${isActive ? 'active' : ''} ${hasAudio ? 'ready' : ''}`}
      onClick={onClick}
      data-testid={`chapter-card-${chapter.id}`}
    >
      <div 
        className="chapter-card-image" 
        style={{ backgroundImage: `url(${imageUrl})` }}
      >
        <div className="chapter-card-overlay">
          <Icon size={24} />
        </div>
      </div>
      <div className="chapter-card-content">
        <span className="chapter-card-number">Chapter {index + 1}</span>
        <span className="chapter-card-title">{chapter.title}</span>
        <span className="chapter-card-time">
          {formatTime(chapter.start_time)} - {formatTime(chapter.end_time)}
        </span>
        <ChapterStatus hasAudio={hasAudio} isProcessing={isProcessing} />
      </div>
    </button>
  );
}

function ChapterStatus({ hasAudio, isProcessing }) {
  if (isProcessing) {
    return (
      <span className="chapter-status processing">
        <Loader2 className="spin" size={12} /> Generating...
      </span>
    );
  }
  
  if (hasAudio) {
    return <span className="chapter-status ready">Ready</span>;
  }
  
  return null;
}

function formatTime(time) {
  const mins = Math.floor(time / 60);
  const secs = Math.floor(time % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export { formatTime };
